import get from 'lodash/get.js'
import {showConfirmMessageModal} from '../../../common/components/Modal/ConfirmMessageModal.js'
import {cartVendorsByName} from '../../../common/constants/CartVendorOptions.js'
import {formSelector, getState} from '../../../store.js'
import FormListItem from '../Common/FormListItem.js'
import {getAuthorizeMessage} from './AuthorizeMessage.js'
import ButtonPrimary from '../../../common/components/Button/ButtonPrimary.js'
import ButtonLink from '../../../common/components/Button/ButtonLink.js'
import {setCart} from '../../../data/carts.js'

export async function showReauthorizeCartModal(formName) {
  const cartForm = formSelector(getState(), {formName})
  const vendorName = get(cartVendorsByName[cartForm.vendor], 'display', '')

  await showConfirmMessageModal({
    title: 'Reauthorize sales channel',
    Message: () => (
      <div className="row">
        <div className="medium-12 columns">
          <p className="margin-top-10 margin-bottom-10">
            {getAuthorizeMessage(vendorName)}
          </p>
        </div>
      </div>
    ),
    modalSize: 'sm',
    confirmText: 'Reauthorize Cart',
    cancelText: 'Cancel',
    async onResolve({outcome}) {
      if (!outcome) {
        return
      }

      await cartForm.authorize(formName)
    },
  })
}

export async function showRevokeCartModal(formName) {
  const cartForm = formSelector(getState(), {formName})
  const vendorName = get(cartVendorsByName[cartForm.vendor], 'display', '')

  await showConfirmMessageModal({
    title: 'Remove Authorization',
    Message: () => (
      <div className="row">
        <div className="medium-12 columns">
          <p className="margin-top-10 margin-bottom-10">
            Do you want to remove authorization for {vendorName}. You can
            reauthorize later if you want.
          </p>
        </div>
      </div>
    ),
    modalSize: 'sm',
    confirmText: 'Remove',
    cancelText: 'Cancel',
    async onResolve({outcome}) {
      if (!outcome) {
        return
      }

      const cart = await cartForm.revoke(formName)

      setCart(cart)
    },
  })
}

/**
 * Button component for reauthorizing a sales channel.
 *
 * @param {Object} props - The component props
 * @param {React.ReactNode} props.children - The content to display inside the button
 * @param {Function} [props.onClick] - The function to call when the button is clicked
 * @param {String} props.formName - The name of the settings form
 * @param {Boolean} props.hasRevoke - Can revoke account authorization
 * @param {Function} [props.onRevokeClick] - The function to call when the revoke button is clicked
 *
 * @returns {React} - The ReauthorizeButton component
 */
export default function ReauthorizeButton({
  children,
  onClick,
  formName,
  hasRevoke,
  onRevokeClick,
}) {
  return (
    <FormListItem className="divider--top">
      <div className="fs-00 margin-bottom-3">
        {children || <strong>Account Authentication</strong>}
      </div>
      <ButtonPrimary
        className="reauthorize"
        size="sm"
        isOutlined
        onClick={() =>
          onClick ? onClick(formName) : showReauthorizeCartModal(formName)
        }
      >
        Reauthorize
      </ButtonPrimary>
      {hasRevoke && (
        <ButtonLink
          className="margin-left-10"
          size="sm"
          onClick={() =>
            onRevokeClick
              ? onRevokeClick(formName)
              : showRevokeCartModal(formName)
          }
        >
          Remove
        </ButtonLink>
      )}
    </FormListItem>
  )
}
